import { componentsReady } from '@porsche-design-system/components-react';
import { spacingFluidMedium, spacingFluidSmall } from '@porsche-design-system/components-react/styles';
import { useEffect } from 'react';
import styled, { css } from 'styled-components';

const overrideCss = css`
    :host .root {
        /* content background color */
        --_b: #eeeff2;
        /* sidebar background color */
        --_c: #fff;
    }

    :host .root aside.sidebar.sidebar--end {
        background-color: #fff;
    }

    :host .root aside.sidebar.sidebar--start .sidebar__content {
        --sidebar-padding: clamp(16px, 1.25vw + 12px, 24px);
        --sidebar-header-height: 56px;
        height: calc(100% - (var(--sidebar-padding) * 2) - var(--sidebar-header-height));
    }
`;

export const SidebarStartSlot = styled.div`
    height: 100%;

    @media (max-width: 760px) {
        /* padding-block set in flyout */
        --flyout-padding-height: calc(${spacingFluidSmall} + ${spacingFluidMedium});
        height: calc(100vh - (var(--flyout-padding-height) * 2));
    }
`;

const useLayoutStyle = (wrapperRef: React.RefObject<HTMLDivElement>) => {
    useEffect(() => {
        const wrapper = wrapperRef.current;
        if (!wrapper) {
            return;
        }

        componentsReady(wrapper).then(() => {
            const shadowRoot = wrapper.querySelector('p-canvas')?.shadowRoot;
            if (!shadowRoot) {
                return;
            }

            const style = document.createElement('style');
            style.textContent = overrideCss.toString();
            shadowRoot.appendChild(style);
        });
    }, [wrapperRef]);
};

export default useLayoutStyle;
